import React from 'react';

import NewsletterTemplateSelection from '../../components/Communication/NewsletterTemplateSelection';

function NewsletterTemplateSelectionView() {
  return <NewsletterTemplateSelection />;
}

export default NewsletterTemplateSelectionView; 